import { useEffect, useState } from "react";

// material-ui
import { Box, Grid, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// project imports
import Logo from "features/layout/Logo";
import HeaderContent from "features/layout/HeaderContent";
import HeaderSignedOut from "features/layout/HeaderSignedOut";
import CurrentSession from "data/userSession";
import AnalyticsService from "data/firestore/analytics";
import useCustomNavigation from "hooks/customNavigation";

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
  const theme = useTheme();
  const navigate = useCustomNavigation();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [signedIn, setSignedIn] = useState(false);
  const [user, setUser] = useState<any>(null);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    CurrentSession.load().then((user) => {
      if (cancelled) return;
      AnalyticsService.pageView();
      setSignedIn(CurrentSession.isSignedIn);
      setUser(CurrentSession.firebaseUser);
      setAuthLoading(false);

      // Redirect logic when first loading. Guarded so a late resolve can't
      // yank the user to /profile after they've navigated elsewhere.
      if (
        CurrentSession.authenticationStrictlyMatches(user.uid) &&
        user.incompleteSignup
      ) {
        navigate("profile");
      }
    });

    // Listen for authentication state changes
    const handleAuthStateChange = () => {
      CurrentSession.load().then((user) => {
        setSignedIn(CurrentSession.isSignedIn);
        setUser(CurrentSession.firebaseUser);
        setAuthLoading(false);
      });
    };

    window.addEventListener("authStateChanged", handleAuthStateChange);

    return () => {
      cancelled = true;
      window.removeEventListener("authStateChanged", handleAuthStateChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Mobile layout: Logo on left, items evenly spaced on right (no spacer)
  // Desktop layout: Logo on left, spacer, items on right
  return (
    <Grid
      container
      sx={{
        alignItems: "center",
        justifyContent: isMobile ? "space-between" : "center",
        flexWrap: "nowrap",
        width: "100%",
      }}
    >
      {/* Logo */}
      <Grid item sx={{ flexShrink: 0 }}>
        <Logo user={user} />
      </Grid>

      {/* Spacer - only on desktop */}
      {!isMobile && <Box sx={{ flexGrow: 1 }} />}

      {/* Content area */}
      <Grid
        item
        sx={{
          flexGrow: isMobile ? 1 : 0,
          display: "flex",
          justifyContent: isMobile ? "space-evenly" : "flex-end",
          alignItems: "center",
        }}
      >
        {authLoading ? null : signedIn ? (
          <HeaderContent userId={user?.uid} />
        ) : (
          <HeaderSignedOut />
        )}
      </Grid>
    </Grid>
  );
};

export default Header;
